import datasetTabTemplate from './datasetTabTemplate';

export default datasetTabTemplate(['dataset'], ({ datasets }) => datasets.create);
